export function isNullish(value) {
    return isNull(value) || isUndefined(value);
}
export function isUndefined(value) {
    return value === undefined;
}
export function isNull(value) {
    return value === null;
}
